import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useUser } from '../context/UserContext';

const NewDrill = () => {
  const [drillName, setDrillName] = useState('');
  const [gifFile, setGifFile] = useState(null);
  const navigate = useNavigate();
  const { userData } = useUser();
  const userId = userData?.userId;
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const location = useLocation();
  const sportId = location.state?.sportId;
  const drillId = location.state?.drillId;
  const drillImage = location.state?.image;
  const categoryId = location.state?.categoryId;
  const DrillName = location.state?.DrillName;
  useEffect(() => {
    if (DrillName) {
      setDrillName(DrillName);
    }
  }, [DrillName]);

  const handleGifUpload = (e) => {
    const file = e.target.files[0];
    const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];

    if (!file) return;

    if (!validTypes.includes(file.type)) {
      setErrorMessage("Please upload a valid image file (PNG, JPG, JPEG, GIF).");
      return;
    }

    setGifFile(file);
    setErrorMessage('');
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!drillId && !gifFile) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select an image file before submitting.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    const fileName = gifFile ? gifFile.name : `drill_${Date.now()}.gif`;
    const apiUrl = `${process.env.REACT_APP_API_DRILLS_CREATE}?sportId=${sportId}&categoryId=${categoryId}&name=${encodeURIComponent(drillName)}&drillId=${drillId || ''}&loginUserId=${userId}`;

    const formData = new FormData();
    if (gifFile) {
      formData.append("file", gifFile, fileName); 
    }
    formData.append("fileName", fileName);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          'x-authorization': process.env.REACT_APP_AUTH_TOKEN,
        },
        body: formData,
      });

      if (response.ok) {
        const successMessage = drillId ? "Drill updated successfully!" : "Drill created successfully!";
        navigate(-1);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: successMessage,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        setSuccessMessage(successMessage);
        setDrillName("");
        setGifFile(null);
      } else {
        let errorText = "Something went wrong!";
        try {
          const errorData = await response.json();
          errorText = errorData.message || errorText;
        } catch (_) { }

        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorText,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        setErrorMessage(errorText);
      }
    } catch (error) {
      console.error('Upload failed:', error);

      const errorMsg = error?.message?.toLowerCase() || '';

      if (errorMsg.includes('413') || errorMsg.includes('entity too large') || errorMsg.includes('request entity too large')) {
        Swal.fire({
          icon: "error",
          title: "File Too Large",
          text: "The uploaded file is too large. Please upload a smaller file (under 50MB).",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
        });
        setErrorMessage("File too large.");
      } else {
        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          text: "Something went wrong. Please try again.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        setErrorMessage("An error occurred. Please try again.");
      }
    }

  };

  return (
    <div className="enrollment-container">
      <div className="breadcrumb">
        <Link to="/sportList" className="breadcrumb-link">Sport List</Link> &gt; Create Drill
      </div>
      <form onSubmit={handleSubmit}>
        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <input
            id="drill-name-input"
            type="text"
            name="drillName"
            className={`walkin-form ${drillName ? 'has-value' : ''}`}
            value={drillName}
            onChange={(e) => setDrillName(e.target.value)}
            placeholder="Enter Drill Name"
            required
          />
          {drillName && (
            <label htmlFor="drill-name-input">Drill Name</label>
          )}
        </div>

        {drillImage && !gifFile && (
          <div>
            <img src={drillImage} alt="Drill" style={{ width: '300px', height: '300px' }} />
          </div>
        )}

        {gifFile && (
          <div>
            <img src={URL.createObjectURL(gifFile)} alt="Uploaded" style={{ width: '300px', height: '300px' }} />
          </div>
        )}
        <button
          className="uploadbutton"
          type="button"
          onClick={() => document.getElementById("gif-upload").click()}
        >
          <span className="uploadbutton__icon">
            <svg
              strokeLinejoin="round"
              strokeLinecap="round"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              viewBox="0 0 24 24"
              height="24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path fill="none" d="M0 0h24v24H0z" stroke="none"></path>
              <path d="M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1"></path>
              <path d="M9 15l3 -3l3 3"></path>
              <path d="M12 12l0 9"></path>
            </svg>
          </span>
          <span className="uploadbutton__text">Upload</span>
        </button>

        <input
          id="gif-upload"
          type="file"
          accept="image/png, image/jpeg, image/jpg, image/gif"
          onChange={handleGifUpload}
          style={{ display: 'none' }}
        />


        <button className='submit-button' type="submit">Submit</button>
      </form>
    </div>
  );
};

export default NewDrill;
